import PropTypes from 'prop-types';
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';

import PopupContext from '../../popup/utils/PopupContext';
import VideoPlayer from '../../ui/videoPlayer/containers/VideoPlayer';
import FinishCoursePopUp from './FinishCoursePopUp';

const INTERVAL = 10000;

const CourseVideo = ({
  isPreviousDisable,
  isNextDisable,
  currentVideo,
  onStoppedWatchVideo,
  onPreviousVideoClick,
  onNextVideoClick,
  onVideoWathced,
}) => {
  const refCurrentTime = useRef();
  const {openPopup} = useContext(PopupContext);

  const [isShowCertificate, setShowCertificate] = useState(false);
  const [certificateID, setCertificateID] = useState(null);
  const [isVideoStopped, setVideoStopped] = useState(false);
  const isUserAuthorized = getAuthorizationToken();

  const handleVideoTimeTrack = useCallback(async () => {
    if (refCurrentTime.current && isUserAuthorized) {
      const {status, responseBody} = await onStoppedWatchVideo(
        currentVideo.id,
        refCurrentTime.current
      );

      if (
        status === RESPONSE_STATUSES.SUCCESS &&
        responseBody.is_certificate_needed
      ) {
        setCertificateID(responseBody.certificate_id);
        setShowCertificate(responseBody.is_certificate_needed);
      }
    }
  }, [refCurrentTime, currentVideo]);

  useEffect(() => {
    if (isShowCertificate && certificateID && isVideoStopped) {
      setShowCertificate(false);

      // @ts-ignore
      openPopup({
        popup: <FinishCoursePopUp certificateId={certificateID} />,
        options: {withCloseButton: true},
      });
    }
  }, [isVideoStopped, isShowCertificate, certificateID]);

  useEffect(() => {
    const inteval = setInterval(() => {
      handleVideoTimeTrack();
    }, INTERVAL);

    return () => {
      handleVideoTimeTrack();
      refCurrentTime.current = null;
      clearInterval(inteval);
    };
  }, [currentVideo]);

  const handleOnStoppedVideo = useCallback(
    (isStopped) => {
      setVideoStopped(isStopped);
      onVideoWathced();
      handleVideoTimeTrack();
    },
    [currentVideo]
  );

  const handleSetCurrentTime = useCallback((time) => {
    return (refCurrentTime.current = time);
  }, []);

  return (
    <VideoPlayer
      isPreviousDisable={isPreviousDisable}
      isNextDisable={isNextDisable}
      onPreviousVideoClick={onPreviousVideoClick}
      onNextVideoClick={onNextVideoClick}
      onStopClick={handleOnStoppedVideo}
      onVideoFinish={handleOnStoppedVideo}
      setCurrentTime={handleSetCurrentTime}
      {...currentVideo}
    />
  );
};

CourseVideo.propTypes = {
  isPreviousDisable: PropTypes.bool.isRequired,
  isNextDisable: PropTypes.bool.isRequired,
  currentVideo: PropTypes.object.isRequired,
  onStoppedWatchVideo: PropTypes.func.isRequired,
  onPreviousVideoClick: PropTypes.func.isRequired,
  onNextVideoClick: PropTypes.func.isRequired,
  onVideoWathced: PropTypes.func.isRequired,
};

export default CourseVideo;
